export default __webpack_public_path__ + "static/media/Group.ccad8aba.svg";